<div class="container">
    <div class="row">
        <div class="col section-title-full">
            <h1>
                <span i18n>Detalle de autorización</span>
            </h1>
        </div>
    </div>
</div>

<div class="container">
    <div class="row my-5" *ngIf="exception">
        <div class="col">
            <button type="button" class="btn btn-outline-secondary" (click)="goBack()">Volver</button>
            <div class="row">
                <div class="col-12">
                    <h2 class="my-4" i18n>Datos autorización</h2>
                    <div class="card">
                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <label for="vehicle" class="form-label"><span i18n>Matrícula</span>: </label>
                                <p>{{exception.vehiclePlate}}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="driver" class="form-label">
                                    <span i18n>Conductor</span>:
                                </label>
                                <p>{{exception.applicantIdentifier}}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="poblation" class="form-label"><span i18n>Población</span>: </label>
                                <p>{{exception.municipalities}}</p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="status" class="form-label"><span i18n>Estado</span>: </label>
                                <p><app-status-tag [status]="exception.state" [simple]="true"></app-status-tag></p>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="vehicleType" class="form-label"><span i18n>Tipo de vehículo</span>: </label>
                                <p>{{exception.type.name}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <h2 class="my-4" i18n>Estados</h2>

                    <div class="card">
                        <div class="col-12">
                            <div class="states-box">
                                <div class="message" *ngFor="let state of exception.states"
                                    [ngClass]="state.ticket.sourceProfile"
                                    [ngStyle]="{'background-color': state.ticket.background, 'color': state.ticket.foreground}">
                                <p>{{state.ticket.sourceUser}}</p>
                                <p>{{state.ticket.observations}}</p>
                                <span>{{state.timestamp.timestamp | date:'dd/MM/yyyy HH:mm'}}</span>
                            </div>
                        </div>
                        <div class="card send-observation">
                            <div class="form-group mb-3">
                                <label for="observation" class="form-label" i18n>Observaciones</label>
                                <textarea class="form-control" id="observation" rows="3"
                                    [(ngModel)]="observation"></textarea>
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-primary" (click)="sendObservation()" i18n>Enviar
                                    comentario</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <h2 class="my-4" i18n>Ficheros</h2>
                <div class="card">
                    <div class="col-12 mb-3">
                        <label for="formFileMultiple" class="form-label"><span i18n>Documentos</span>: </label>
                        <div>
                            <app-custom-input-file (onFileSelected)="addFiles($event)"
                                *ngIf="showFileInput"></app-custom-input-file>
                        </div>
                        <small i18n>Tamaño de fichero máximo de 5MB</small>
                    </div>
                    <div class="col-12">
                        <table class="table table-responsive table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" i18n>Nombre</th>
                                    <th scope="col" i18n>Tipo</th>
                                    <th scope="col" i18n>Fecha</th>
                                    <th class="col col-actions" scope="col" i18n>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let file of exception.attachments">
                                    <td>{{file.name}}</td>
                                    <td>{{file.mime}}</td>
                                    <td>{{file.timestamp?.timestamp | date}}</td>
                                    <td class="col col-actions">
                                        <button type="button" class="btn btn-outline-primary btn-icon"
                                            (click)="downloadFile(file)" *ngIf="file.uuid"><i
                                                class="bi bi-download"></i></button>
                                        <button type="button" class="btn btn-outline-danger btn-icon"
                                            (click)="removeFile(file.uuid)" *ngIf="file.uuid"><i
                                                class="bi bi-trash3-fill"></i></button>
                                    </td>
                                </tr>
                                <tr *ngIf="exception.attachments.length == 0">
                                    <td colspan="4" class="text-center" i18n>No hay ficheros</td>
                                </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row mb-5">
    <div class="col text-center">
        <button type="button" class="btn btn-outline-secondary" (click)="goBack()" i18n>Volver</button>
    </div>
</div>
</div>